import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';
import {
    DividerMenuIcon,
    DividerMenuOpenedIcon,
    ExpandMenuIcon,
    MenuBackButtonIcon,
} from '../../svg/TemplateIcons';

const TemplateDetailsControlRail = ({
    t,
    tabs,
    currentTab,
    currentDashboard,
    isMobileTemplateDetailsLayout,
    isMobileDetailsRailOpen,
    effectiveDetailsRailExpanded,
    navigate,
    setTabsWidth,
    setCurrentTab,
    setSearchParams,
    setEditingTabRoleData,
    setIsMobileDetailsRailOpen,
}) => (
    <>
        {isMobileTemplateDetailsLayout && isMobileDetailsRailOpen ? (
            <button
                type="button"
                className="details-control-panel-backdrop"
                onClick={() => setIsMobileDetailsRailOpen(false)}
                aria-label={t.closeTabs || 'Close tabs'}
            />
        ) : null}
        <div
            className={
                'details-control-panel' +
                (isMobileTemplateDetailsLayout ? ' details-control-panel-mobile' : '') +
                (isMobileTemplateDetailsLayout && isMobileDetailsRailOpen ? ' details-control-panel-mobile-open' : '')
            }
        >
            <div className="details-control-panel-inside" />

            <div className="details-control-panel-content">
                <div
                    className={`details-control-btns ${
                        effectiveDetailsRailExpanded ? 'details-control-btns-row' : 'details-control-btns-column'
                    }`}
                >
                    <button
                        type="button"
                        className="details-control-btn details-control-btn-ghost"
                        onClick={() => navigate('/configuration/templates')}
                    >
                        <MenuBackButtonIcon />
                    </button>

                    {isMobileTemplateDetailsLayout ? (
                        <button
                            type="button"
                            className="details-control-btn details-control-btn-ghost details-control-mobile-close"
                            onClick={() => setIsMobileDetailsRailOpen(false)}
                            aria-label={t.closeTabs || 'Close tabs'}
                        >
                            <CloseIcon fontSize="small" />
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="details-control-btn details-control-btn-ghost"
                            onClick={() => setTabsWidth((prev) => !prev)}
                        >
                            <ExpandMenuIcon />
                        </button>
                    )}
                </div>

                <div
                    className={
                        'details-control-divider ' +
                        (effectiveDetailsRailExpanded
                            ? 'details-control-divider-expanded'
                            : 'details-control-divider-collapsed')
                    }
                >
                    {effectiveDetailsRailExpanded ? <DividerMenuOpenedIcon /> : <DividerMenuIcon />}
                </div>

                <div
                    className={
                        'details-control-tabs details-control-tabs-rail ' +
                        (effectiveDetailsRailExpanded
                            ? 'details-control-tabs-expanded'
                            : 'details-control-tabs-collapsed')
                    }
                >
                    {tabs.map((tab, idx) => {
                        const isActive = idx === currentTab;

                        return (
                            <Tooltip title={tab.name} placement="right" key={idx}>
                                <div
                                    className={
                                        'details-control-tab details-control-tab-rail ' +
                                        (isActive ? 'active ' : '') +
                                        (effectiveDetailsRailExpanded
                                            ? 'details-control-tab-rail-expanded'
                                            : 'details-control-tab-rail-collapsed')
                                    }
                                    onClick={() => {
                                        setCurrentTab(idx);
                                        setSearchParams((prev) => {
                                            prev.set('tab', idx.toString());
                                            if (tab.name === t.tabs.webdashboard) {
                                                if (!prev.has('dashboardIdx')) prev.set('dashboardIdx', currentDashboard.toString());
                                            } else {
                                                prev.delete('dashboardIdx');
                                            }
                                            return prev;
                                        }, { replace: true });
                                        setEditingTabRoleData(null);
                                        setIsMobileDetailsRailOpen(false);
                                    }}
                                >
                                    {isActive && (
                                        <div className="details-control-tab-cyan-bar" />
                                    )}

                                    <span
                                        className={
                                            'details-control-tab-icon ' +
                                            (effectiveDetailsRailExpanded
                                                ? 'details-control-tab-icon-expanded'
                                                : '')
                                        }
                                    >
                                        {tab.icon || 'â€¢'}
                                    </span>

                                    {effectiveDetailsRailExpanded && (
                                        <span className="details-control-tab-label">
                                            {tab.name}
                                        </span>
                                    )}
                                </div>
                            </Tooltip>
                        );
                    })}
                </div>
            </div>
        </div>
    </>
);

export default TemplateDetailsControlRail;
